/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

 window._ = require('lodash');

 // Jquery
 try {
    window.$ = window.jQuery = require('jquery');
    require('jquery-validation');
    window.Popper = require('popper.js').default;

    window.$ = window.jQuery = require('./bootstrap-hover-dropdown');

    require('bootstrap');
} catch (e) { print(e); }



